import React from 'react'
import common from '@/public/common'
import _ from 'lodash'
import { Button } from 'antd'
import PropTypes from 'prop-types'
import {numberFormat} from '@/utils'
import {qwWxShareFn} from '../utils'
import style from './ProductItem.module.less'

function ProductItem(props) {
  const {data,sale_store_code,brandName} = props
  const getData=(key,place,fn)=>{
    if((place&&typeof place!=='string')){
      return place(data[key])
    }else if(fn){
      return fn(data[key])
    }else{
      return _.get(data,key,place||'--')
    }
  }
  const wxShareFn=()=>{
      const {item_name,item_image,item_id} = data
      const _link = '/pages/productdetail/productdetail.html?itemid='+item_id
      const _webUrl = `${common.m_main_url}item${item_id}.html`
      qwWxShareFn({
        title:item_name,
        imgUrl:item_image.replace(/\/\d+-\d+\//g, '/500-500/'),
        link:_link,
        brandName:brandName,
        webUrl:_webUrl
      })
  }
  return (
    <div className={style.ProductItem}>
      <img src={getData('item_image')}></img>
      <section className={style.content}>
        <p>{getData('item_name')}</p>
        <p style={{fontSize:13,color:'rgba(0,0,0,.5)'}}>{getData('sku_info')}</p>
        <div className={style.footer}>
          <span className={style.txt}>
            <span style={{marginRight:8,fontSize:12,fontWeight:600}}>
              ￥
              <span style={{fontSize:16}}>
                {
                  getData('unit_price',(v)=>{
                    if(v){
                      return numberFormat(v,2)
                    }
                    return '--'
                  })
              }
              </span>
            </span>
            <span>{`×${getData('buy_count')}`}</span>
          </span>
          {sale_store_code=='SigoWeb'?
          data.warehouse_state==0?
          <span style={{color:'rgba(0, 0, 0, 0.5)'}}>缺货</span>:
          data.warehouse_state==2?
          <span style={{color:'rgba(0, 0, 0, 0.5)'}}>下架</span>:
          <Button size='small' type='primary' onClick={()=>{
            wxShareFn(data)
          }}>发送</Button>
          :null}
        </div>
      </section>
    </div>
  )
}
ProductItem.propTypes = {
  data:PropTypes.object,
  sale_store_code:PropTypes.string,
  brandId:PropTypes.string
}
ProductItem.defaultProps = {
  data:{},
  sale_store_code:''
}
export default ProductItem


// WEBPACK FOOTER //
// ./src/pages/udeskSide/components/ProductItem.js